export const modalModifiers = ['narrow'];

export const getInitialState = () => ({
  allowToPasteShiftsInNotVisibleDates: false,
  allowToFreeDaysPasteInNotVisibleDates: false,
});
